import { useEffect } from 'react';
import { useAppDispatch } from 'shared/hooks';

import { fetchCurrentCandidateEmailThunk, initialState } from '../store/authSlice';

export default function useFetchEmailOnInit() {
    const dispatch = useAppDispatch();

    useEffect(function fetchEmailOnInit() {
        if (initialState.accessToken.token && !initialState.accessToken.fullAccess) {
            dispatch(fetchCurrentCandidateEmailThunk());
        }
    }, [ dispatch ]);
}
